window.tzx_czcPush = function () {
  /*
   * _czc.push(["_trackEvent",category,action,label,value,nodeid]) // 官方具体参数
   * 第一个category 类别名称, 最后一个value传具体的值
   * 中间的,action,label根据情况可传可不传，具体会拿出 first 和 value 放到具体自动填充 其余按照顺序加入
   */
  if (window._czc) {
    // 增加友盟方法判断
    let argus = [...arguments]
    let first = argus.shift()
    let value = argus.pop() // value 一般调用方法的时候最后传
    let pushData = ['_trackEvent', first, ...argus]
    pushData[3] = value // push 官方 第5个参数只能是整数型数据，暂时给 第3个索引复制传入的值
    _czc.push(pushData)
    // if (process.env.NODE_ENV === 'production') _czc.push(pushData)
  }
}

Date.prototype.format = function (str) {
  let fill = (num) => {
    if ((num + '').length == 2) return num + ''
    else return '0' + num
  }
  let date = this
  str = str || '-'
  let arr = [date.getFullYear(), fill(date.getMonth() + 1), fill(date.getDate())]
  let arr1 = [fill(date.getHours()), fill(date.getMinutes() + 1), fill(date.getMinutes())]
  return arr.join(str) + ' ' + arr1.join(':')
}

String.prototype.getByteLength = function () {
  const primit = this.valueOf()
  if (primit === null) return 0
  if (typeof primit !== 'string') {
    const convert = primit + ''
    return convert.replace(/[^\x00-\xff]/g, '01').length
  }
  return primit.replace(/[^\x00-\xff]/g, '01').length
}

String.prototype.widthForFontsize = function (size) {
  let span = document.getElementById('_str_byteLengthID')
  if (span === null) {
    span = document.createElement('span')
    span.id = '_str_byteLengthID'
    span.style.position = 'fixed'
    span.style.left = '-1000px'
    span.style.bottom = '-100px'
    span.style.display = 'inline-block'
    span.style.visibility = 'hidden'
    span.style.width = 'auto'
    span.style.whiteSpace = 'nowrap'
  }
  document.body.appendChild(span)
  span.innerText = this
  span.style.fontSize = size + 'px'

  const fontWidth = span.offsetWidth

  const t = setTimeout(() => {
    clearTimeout(t)
    document.body.removeChild(span)
  }, 0)
  return fontWidth
}

function handleCasTicket() {
  // console.log('handleCasTicket')
  const { origin, pathname, search } = window.location
  const U_TK = 'ticket='
  if (search && search.indexOf(U_TK) > -1) {
    const tck = search.match(/(^|\?|&)ticket=([^&]*)/g)
    if (tck && tck.length) {
      const tkStr = tck[0]
      const tkt = tkStr.split(U_TK)[1]
      if (tkt) localStorage.setItem('user_ticket', tkt)
      let ots = search.replace(tkStr, '')
      if (ots && ots[0] === '&') ots = ots.replace(ots[0], '?')
      if ('replaceState' in history) {
        // 注:用于替换的url不可跨域
        history.replaceState(null, '', origin + pathname + ots)
      } else {
        // 降级方案:刷新页面
        window.location.replace(origin + pathname + ots)
      }
    }
  }
}
